import type { Listing } from '@thevillages/schemas';

import { CurrencyPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';

import { StateService } from '../../../../services/state/state';

@Component({
  imports: [CurrencyPipe],
  selector: 'app-map-listing-popover-homesite',
  styleUrl: './homesite.css',
  templateUrl: './homesite.html',
})
export class MapListingPopoverHomesite {
  protected readonly stateService = inject(StateService);

  public readonly listing = input.required<Listing>();
}
